import { render } from "./TinymceEditor.vue?vue&type=template&id=a9d8bebe&scoped=true"
import script from "./TinymceEditor.vue?vue&type=script&lang=js"
export * from "./TinymceEditor.vue?vue&type=script&lang=js"

import "./TinymceEditor.vue?vue&type=style&index=0&id=a9d8bebe&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9d8bebe"]])

export default __exports__